import React, { useContext } from "react";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Tooltip from '@mui/material/Tooltip';

import DivSpinner from "../../divSpinner";
import { theme } from "../../../theme";
import CreditNotesPagination from "./creditNotesPagination";
import { Context } from "../provider";
import { openCreditNotePDF } from "../service";

const CreditNotesList = () => {
    const context = useContext(Context);

    return(
        <>
            {context.state.is_loading_credit_notes ? (
                <div style={{height : `${window.innerHeight-387}px`}}>
                    <DivSpinner/>
                </div>
            ) : (
                <div className="table-responsive p-0 m-3">
                    <table className="table align-items-center mb-0">
                        <thead>
                            <tr>
                                {[ 
                                    'Job ID', 
                                    'Customer', 
                                    'Description', 
                                    'Amount'
                                ].map((text, index) => (
                                    <th 
                                        key={index}
                                        className="text-uppercase text-secondary text-sm font-weight-bolder opacity-7"
                                    >
                                        {text}
                                    </th>
                                ))}
                                <th className="text-secondary opacity-7"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {context.state.credit_notes.length > 0 ? (
                                <>
                                    {context.state.credit_notes.map((credit_note, index) => (
                                        <tr key={index}>
                                            <td className="align-middle">
                                                <span className="text-secondary text-sm font-weight-bold">{credit_note?.credit_note_job_id}</span>
                                            </td>
                                            {[
                                                credit_note?.customer_full_name,
                                                credit_note?.credit_note_description,
                                                `${theme.currency} ${credit_note?.credit_note_amount}`
                                            ].map((text, index) => (
                                                <td className="align-middle" key={index}>
                                                    <span className="text-secondary text-sm font-weight-bold">
                                                        {text}
                                                    </span>
                                                </td>
                                            ))}
                                            <td className="align-middle">
                                            <Tooltip title="Open Credit Note" arrow>
                                                <PictureAsPdfIcon 
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => openCreditNotePDF(credit_note.credit_note_id)}
                                                />
                                            </Tooltip>
                                            </td> 
                                        </tr>
                                    ))}
                                </>
                            ) : (
                                <tr>
                                    <td colSpan="8">Sorry, no data found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <CreditNotesPagination/>
                </div>
            )}
        </>
    );
}

export default CreditNotesList;